import styled from 'styled-components';

export const FormTable = styled.table`
  width: 100%;
`;

export const FormTableRow = styled.tr`
  border-bottom: 1px solid #ddd;
`;

interface IFormTableHeaderCellProps {
  width?: string;
}

export const FormTableHeaderCell = styled.th<IFormTableHeaderCellProps>`
  font-weight: bold;
  width: ${props => props.width || 'auto'};
  min-width: ${props => props.width || 'auto'};
  padding: 5px;
`;

export const FormTableDataCell = styled.td`
  padding: 5px;
`;